import { lazy, type ComponentType } from 'react'

const RELOAD_KEY = 'quiz.chunkReloadAt'

/**
 * React.lazy for route pages, surviving releases: a release replaces the hashed
 * chunk files, so a tab opened before it can request a chunk that no longer
 * exists. On that failure, reload once to pick up the new index.html. A
 * timestamp guard prevents a reload loop if the chunk is genuinely broken.
 */
export function lazyPage<T extends ComponentType<object>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      return await load()
    } catch (err) {
      let last = 0
      try { last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0) } catch { /* storage unavailable */ }
      if (Date.now() - last > 10_000) {
        try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())) } catch { /* storage unavailable */ }
        window.location.reload()
        return await new Promise<never>(() => {})   // page is reloading
      }
      throw err
    }
  })
}
